// Create mixins

export default {
  methods: {
    mask() {
      this.$ebus.$emit('c-mask-lock');
    },
    unmask() {
      this.$ebus.$emit('c-mask-unlock');
    },
  },
};
